import { render, staticRenderFns } from "./add-cpd-activity-category.vue?vue&type=template&id=4d696f84&scoped=true"
import script from "./add-cpd-activity-category.vue?vue&type=script&lang=js"
export * from "./add-cpd-activity-category.vue?vue&type=script&lang=js"
import style0 from "./add-cpd-activity-category.vue?vue&type=style&index=0&id=4d696f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d696f84",
  null
  
)

export default component.exports